import { render, staticRenderFns } from "./UploadMultiple.vue?vue&type=template&id=64c122d0&scoped=true&"
import script from "./UploadMultiple.vue?vue&type=script&lang=js&"
export * from "./UploadMultiple.vue?vue&type=script&lang=js&"
import style0 from "./UploadMultiple.vue?vue&type=style&index=0&id=64c122d0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c122d0",
  null
  
)

export default component.exports